import {
  AdminsJobBoardsVacanciesGetJobVacancyListResponseItemCategory,
  DeliveryEnum,
  InvoiceStatusEnum,
  JobBoardsVacanciesApplicationStatusEnum,
  JobBoardsVacanciesStatusEnum,
  PaymentMethodEnum,
  PaymentStatusEnum,
  SaleOrderStatusEnum,
  StockLocationStatusEnum,
  UserRoleEnum,
  VendorStatusEnum,
  VendorTypeEnum,
} from 'generated/api'

export const mapStatusOrder = (status: SaleOrderStatusEnum): string => {
  switch (status) {
    case 'DRAFT':
      return 'Menunggu Pembayaran'
    case 'NEW':
      return 'Menunggu Konfirmasi'
    case 'CONFIRMED':
      return 'Sedang Diproses'
    case 'READY_TO_PICK_UP':
      return 'Pesanan Siap'
    case 'DELIVERING':
      return 'Dalam Pengiriman'
    case 'COMPLETED':
      return 'Pesanan Selesai'
    case 'CANCELLED':
      return 'Dibatalkan'
    case 'CANCEL_APPROVAL':
      return 'Permintaan pembatalan'
    default:
      return 'Menunggu Pembayaran'
  }
}

export const mapRole = (role: UserRoleEnum | ''): string => {
  const roleWording: Record<string, string> = {
    [UserRoleEnum.FinanceAccountant]: 'Accounting',
    [UserRoleEnum.WarehouseOfficer]: 'Warehouse',
    [UserRoleEnum.Operation]: 'Operation',
    [UserRoleEnum.Administrator]: 'Administrator',
    [UserRoleEnum.OperationLead]: 'Operation Lead',
    [UserRoleEnum.FinanceLead]: 'Finance Lead',
    default: role,
  }
  return roleWording[role] || roleWording['default']
}

export const mapStatusStockLocation = (status: StockLocationStatusEnum): string => {
  const statusWording: Record<string, string> = {
    [StockLocationStatusEnum.Active]: 'Aktif',
    [StockLocationStatusEnum.Inactive]: 'Tidak Aktif',
    default: status,
  }
  return statusWording[status] || statusWording['default']
}

export const mapVendorType = (type: VendorTypeEnum): string => {
  const typeWording: Record<string, string> = {
    [VendorTypeEnum.FarmerStore]: 'Toko Tani',
    [VendorTypeEnum.GroceryStore]: 'Toko Sembako',
    [VendorTypeEnum.Company]: 'Perusahaan',
    default: type,
  }
  return typeWording[type] || typeWording['default']
}

export const mapStatusVendor = (status: VendorStatusEnum): string => {
  const statusWording: Record<string, string> = {
    [StockLocationStatusEnum.Active]: 'Aktif',
    [StockLocationStatusEnum.Inactive]: 'Tidak Aktif',
    default: status,
  }
  return statusWording[status] || statusWording['default']
}

export const mapStatusPayment = (status: PaymentStatusEnum): string => {
  const statusWording: Record<string, string> = {
    [PaymentStatusEnum.Unpaid]: 'Belum Lunas',
    [PaymentStatusEnum.Paid]: 'Sudah Lunas',
    [PaymentStatusEnum.Expired]: 'Dibatalkan',
    [PaymentStatusEnum.Cancelled]: 'Dibatalkan',
    default: status,
  }
  return statusWording[status] || statusWording['default']
}

export const mapStatusInvoice = (status: InvoiceStatusEnum): string => {
  const statusWording: Record<string, string> = {
    [InvoiceStatusEnum.Paid]: 'Sudah Dibayar',
    [InvoiceStatusEnum.PartialPaid]: 'Dibayar Sebagian',
    [InvoiceStatusEnum.Unpaid]: 'Belum Dibayar',
    [InvoiceStatusEnum.Expired]: 'Kedaluwarsa',
    [InvoiceStatusEnum.Cancelled]: 'Dibatalkan',
    [InvoiceStatusEnum.Void]: 'Void',
    default: status,
  }
  return statusWording[status] || statusWording['default']
}

export const mapStatusDeliveryMethod = (status: DeliveryEnum): string => {
  const statusWording: Record<string, string> = {
    [DeliveryEnum.Pickup]: 'Ambil Sendiri',
    default: status,
  }
  return statusWording[status] || statusWording['default']
}

export const mapStatusProduct = (status: string): string => {
  const statusWording: Record<string, string> = {
    ACTIVE: 'Aktif',
    INACTIVE: 'Tidak Aktif',
    default: status,
  }
  return statusWording[status] || statusWording['default']
}

export const mapPaymentMethod = (paymentMethod: PaymentMethodEnum): string => {
  const paymentMethodWording: Record<string, string> = {
    [PaymentMethodEnum.Transfer]: 'Manual transfer',
    [PaymentMethodEnum.Point]: 'POINT',
    [PaymentMethodEnum.Briva]: 'BRI VA',
    [PaymentMethodEnum.Mandiriva]: 'Mandiri VA',
    [PaymentMethodEnum.TransferAndPoint]: 'Manual transfer dan POINT',
    default: paymentMethod,
  }

  return paymentMethodWording[paymentMethod] || paymentMethodWording['default']
}

export const mapJobVacancyStatus = (status: JobBoardsVacanciesStatusEnum): string => {
  const statusWording: Record<string, string> = {
    [JobBoardsVacanciesStatusEnum.Active]: 'Berjalan',
    [JobBoardsVacanciesStatusEnum.Inactive]: 'Selesai',
    default: status,
  }

  return statusWording[status] || statusWording['default']
}

export const mapJobVacancyCategory = (
  category: AdminsJobBoardsVacanciesGetJobVacancyListResponseItemCategory,
): string => {
  const categoryWording: Record<string, string> = {
    HARVESTER: 'Pemanen',
    UPKEEPER: 'Perawat',
    SHIPPER: 'Pengirim',
    default: category.name,
  }

  return categoryWording[category.name] || categoryWording['default']
}

export const mapJobVacancyApplicantStatus = (
  status: JobBoardsVacanciesApplicationStatusEnum,
): string => {
  const statusWording: Record<string, string> = {
    [JobBoardsVacanciesApplicationStatusEnum.Accepted]: 'Diterima',
    [JobBoardsVacanciesApplicationStatusEnum.Pending]: 'Menunggu',
    [JobBoardsVacanciesApplicationStatusEnum.Rejected]: 'Ditolak',
    default: status,
  }

  return statusWording[status] || statusWording['default']
}
